import { render } from "./UserProfileExample.vue?vue&type=template&id=3668fa58&scoped=true"
import script from "./UserProfileExample.vue?vue&type=script&lang=ts"
export * from "./UserProfileExample.vue?vue&type=script&lang=ts"

import "./UserProfileExample.vue?vue&type=style&index=0&id=3668fa58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3668fa58"

export default script